<template>
  <div class="form-group">
    <label
      v-bind:class="{
        'text-danger': current.errors && current.errors.caja,
      }"
      >{{ titulo }}</label
    >
    <select
      class="form-control"
      autofocus="autofocus"
      required
      v-model="current.caja"
      :disabled="isdisabled || disabled"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    >
      <option v-if="incluir_en_blanco" value="">Todas</option>
      <option v-for="(caja, key) in cajas" :value="caja.id" :key="key">
        {{ caja.caja }} - {{ caja.tienda.nombre }}
      </option>
    </select>
    <small
      v-if="current.errors && current.errors.caja"
      class="form-text text-danger"
      >{{ current.errors.caja[0] }}</small
    >
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    tienda: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    titulo: {
      type: String,
      default: "Caja",
    },
    incluir_en_blanco: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cajas: [],
    };
  },
  watch: {
    tienda: function () {
      let self = this;
      DynamicService.fetch("cxc", "caja", {
        tienda: this.tienda,
      }).then((response) => {
        self.cajas = response.data.results;
        return true;
      });
    },
  },
  computed: {
    isdisabled: function () {
      let self = this;
      if (self.current.estado != undefined) {
        return self.current.estado != "A";
      }
      return false;
    },
  },
  mounted() {
    let self = this;
    self.RefreshCajas();
    if (self.current.estado == undefined) {
      self.current.estado = "A";
    }
  },
  methods: {
    RefreshCajas() {
      DynamicService.fetch("cxc", "caja", {
        tienda: this.tienda,
      }).then((response) => {
        this.cajas = response.data.results;
      });
    },
  },
};
</script>
